// Synced from mobile mockData + place/hero images for admin CMS.
export const seedProvinces = [
  {
    "id": "trabzon",
    "name": "Trabzon",
    "slogan": "Sis, yayla ve sahil aynı günde.",
    "story": "Trabzon’da bir sabah sahilde çay içip öğleden sonra yaylada bulutlara dokunursun. Altındere Vadisi’nden Sümela’ya uzanan yol, Uzungöl’ün sisli kıyısı ve Boztepe’den şehre bakan manzara aynı günün parçası olabilir. Sofrada mısır ekmeği, tereyağı ve hamsiyle tamamlanan bu rota; doğa, tarih ve şehir ritmini bir arada sunar.",
    "history": "Trabzon, antik Trapezus’tan Osmanlı’ya uzanan bir liman kentidir. Pontus, Bizans ve Osmanlı izleri surlarda, hanlarda ve manastırlarda hâlâ okunur. Sümela Manastırı, Maçka Vadisi’nin kayalıklarına asılmış en bilinen mirasıdır; şehir merkezindeki Atatürk Köşkü ve ortaçağ sokakları ise günlük keşfe açıktır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Uzung%C3%B6l%2C_Trabzon_2014.jpg/1280px-Uzung%C3%B6l%2C_Trabzon_2014.jpg",
    "landmark": "Uzungöl",
    "historyCoverImage": "https://commons.wikimedia.org/wiki/Special:FilePath/Sumela%20From%20Across%20Valley.JPG?width=1280",
    "themes": [
      "Nature",
      "History",
      "Food",
      "Sea",
      "Culture"
    ],
    "highlights": [
      {
        "id": "h-trabzon-1",
        "title": "Sümela Manastırı",
        "shortDescription": "Kayalığa asılı bir tarih yürüyüşü; vadiden manastıra uzanan rota unutulmaz bir bakış sunar.",
        "theme": "History",
        "locationHint": "Maçka",
        "bestSeason": "Autumn",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Sumela%20From%20Across%20Valley.JPG?width=1280"
      },
      {
        "id": "h-trabzon-2",
        "title": "Uzungöl",
        "shortDescription": "Göl kıyısında sisli bir kaçamak; yayla evleri ve çevredeki yürüyüş parkurları.",
        "theme": "Nature",
        "locationHint": "Çaykara",
        "bestSeason": "Spring",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Uzung%C3%B6l%2C%20Trabzon%202014.jpg?width=1280"
      },
      {
        "id": "h-trabzon-3",
        "title": "Boztepe",
        "shortDescription": "Şehre yukarıdan bakan en iyi çay molası ve gün batımı noktası.",
        "theme": "Culture",
        "locationHint": "Ortahisar",
        "bestSeason": "Summer",
        "imageUrl": "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&q=80"
      },
      {
        "id": "h-trabzon-4",
        "title": "Atatürk Köşkü",
        "shortDescription": "Orman içinde tarihi köşk; kısa bir kültür molası için ideal.",
        "theme": "History",
        "locationHint": "Soğuksu",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-trabzon-1",
        "title": "Yayla rotası",
        "shortDescription": "Kısa yürüyüş + fotoğraf noktaları.",
        "theme": "Adventure",
        "locationHint": "Hıdırnebi",
        "bestSeason": "Summer",
        "imageUrl": null
      },
      {
        "id": "e-trabzon-2",
        "title": "Sahil bisikleti",
        "shortDescription": "Kıyı boyunca rahat bir sürüş.",
        "theme": "Sea",
        "locationHint": "Akçaabat",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "rize",
    "name": "Rize",
    "slogan": "Çayın kokusu, yağmurun ritmi.",
    "story": "Rize’de yağmur manzaranın parçasıdır. Çay bahçeleri basamak basamak yükselir; Ayder’in buharı, Fırtına Vadisi’nin köprüleri ve yayla yolları günün planını kendiliğinden çizer. Kısa bir kaçamakta bile yeşilin farklı tonlarını ve yerel sofranın sıcaklığını hissedersin.",
    "history": "Rize, Osmanlı’dan bu yana çay üretimiyle anılan bir Karadeniz kentidir. Hemşin yaylaları, Laz ve Hemşin kültürü, taş köprüler ve dereler bölgenin kimliğini oluşturur. Ayder ve çevresi hem doğa hem termal mirasın buluşma noktasıdır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Ayder%2C_August_2019_%283%29.jpg/1280px-Ayder%2C_August_2019_%283%29.jpg",
    "landmark": "Ayder Yaylası",
    "historyCoverImage": "https://commons.wikimedia.org/wiki/Special:FilePath/Ayder%2C%20August%202019%20%283%29.jpg?width=1280",
    "themes": [
      "Nature",
      "Food",
      "Adventure",
      "Culture"
    ],
    "highlights": [
      {
        "id": "h-rize-1",
        "title": "Ayder Yaylası",
        "shortDescription": "Kaplıca buharı, yayla havası ve çevredeki yürüyüş rotaları.",
        "theme": "Nature",
        "locationHint": "Çamlıhemşin",
        "bestSeason": "Winter",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Ayder%2C%20August%202019%20%283%29.jpg?width=1280"
      },
      {
        "id": "h-rize-2",
        "title": "Fırtına Vadisi",
        "shortDescription": "Rafting, taş köprüler ve vadi manzaraları.",
        "theme": "Adventure",
        "locationHint": "Ardeşen",
        "bestSeason": "Spring",
        "imageUrl": "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&q=80"
      },
      {
        "id": "h-rize-3",
        "title": "Çay bahçeleri",
        "shortDescription": "Yerel üretim hikâyesi ve tadım molaları.",
        "theme": "Food",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-rize-1",
        "title": "Taş köprüler turu",
        "shortDescription": "Kısa rotada 3 köprü.",
        "theme": "Culture",
        "locationHint": "Fırtına",
        "bestSeason": "Spring",
        "imageUrl": null
      },
      {
        "id": "e-rize-2",
        "title": "Şelale yürüyüşü",
        "shortDescription": "Kolay parkur, bol su sesi.",
        "theme": "Nature",
        "locationHint": "Pokut",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "artvin",
    "name": "Artvin",
    "slogan": "Vadi derin, hikaye daha derin.",
    "story": "Artvin, Karadeniz’in en vahşi ve en sakin yüzünü aynı karede sunar. Borçka Karagöl’ün dinginliği, cam teraslardan bakılan vadiler ve Macahel’in köy kültürü kısa bir rotada bile güçlü iz bırakır.",
    "history": "Artvin, Gürcistan sınırına yakın konumda; tarihi kaleleri, köprüleri ve biyosfer rezervleriyle öne çıkar. Camili (Macahel) UNESCO biyosfer rezervi, bölgenin doğa ve kültür mirasının en güçlü örneklerinden biridir.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/c/cb/Karagol_in_Borcka.jpg",
    "landmark": "Borçka Karagöl",
    "historyCoverImage": "https://commons.wikimedia.org/wiki/Special:FilePath/Karagol%20in%20Borcka.jpg?width=1280",
    "themes": [
      "Nature",
      "Adventure",
      "Culture"
    ],
    "highlights": [
      {
        "id": "h-artvin-1",
        "title": "Borçka Karagöl",
        "shortDescription": "Sakin göl manzarası, kısa yürüyüş ve piknik alanları.",
        "theme": "Nature",
        "locationHint": "Borçka",
        "bestSeason": "Autumn",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Karagol%20in%20Borcka.jpg?width=1280"
      },
      {
        "id": "h-artvin-2",
        "title": "Cam teras & vadi",
        "shortDescription": "Vadiye karşı adrenalinli bakış noktaları.",
        "theme": "Adventure",
        "locationHint": "Arhavi",
        "bestSeason": "Summer",
        "imageUrl": "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-artvin-1",
        "title": "Vadi rotası",
        "shortDescription": "Araç + kısa yürüyüş kombinasyonu.",
        "theme": "Adventure",
        "locationHint": "Borçka",
        "bestSeason": "Autumn",
        "imageUrl": null
      },
      {
        "id": "e-artvin-2",
        "title": "Fotoğraf noktaları",
        "shortDescription": "Altın saat için 3 durak.",
        "theme": "Nature",
        "locationHint": "Merkez",
        "bestSeason": "Autumn",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "samsun",
    "name": "Samsun",
    "slogan": "Kıyıda şehir, içeride tarih.",
    "story": "Samsun’da sahil bandı gün boyu yaşar; biraz içeri gidince tarih anlatmaya başlar. Bandırma Vapuru, Atakum sahili ve şehir parkları Karadeniz temposunu şehir rahatlığıyla birleştirir.",
    "history": "Samsun, Kurtuluş Savaşı’nın başlangıç limanı olarak anılır. Bandırma Vapuru ve çevresindeki müze alanı, 19 Mayıs 1919’un simgesidir. Liman kenti kimliği bugün de sahil yaşamında devam eder.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Samsun_Atakum_Ye%C5%9Filyurt.jpg/1280px-Samsun_Atakum_Ye%C5%9Filyurt.jpg",
    "landmark": "Atakum Sahili",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Samsun_Atakum_Ye%C5%9Filyurt.jpg/1280px-Samsun_Atakum_Ye%C5%9Filyurt.jpg",
    "themes": [
      "Sea",
      "History",
      "Culture",
      "Food"
    ],
    "highlights": [
      {
        "id": "h-samsun-1",
        "title": "Bandırma Vapuru",
        "shortDescription": "Milli Mücadele’nin sembolü; müze gemide tarih turu.",
        "theme": "History",
        "locationHint": "İlkadım",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80"
      },
      {
        "id": "h-samsun-2",
        "title": "Atakum sahili",
        "shortDescription": "Gün batımında uzun yürüyüş ve kıyı kafeleri.",
        "theme": "Sea",
        "locationHint": "Atakum",
        "bestSeason": "Summer",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Samsun%20Atakum%20Ye%C5%9Filyurt.jpg?width=1280"
      },
      {
        "id": "h-samsun-3",
        "title": "Şehir merkezi & pide",
        "shortDescription": "Kısa mola için yerel lezzet ve yürüyüş.",
        "theme": "Food",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-samsun-1",
        "title": "Sahil koşusu",
        "shortDescription": "Düz parkur, kolay tempo.",
        "theme": "Adventure",
        "locationHint": "Atakum",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "sinop",
    "name": "Sinop",
    "slogan": "Karadeniz’in sakin köşesi.",
    "story": "Sinop, kalabalıktan uzak bir nefes gibidir. Kale surları, liman kafeleri ve Hamsilos Koyu’nun fiyort benzeri kıyısı günün ritmini düşürür. Akşamları gün batımı denizle şehir arasında sessiz bir anlaşma yapar.",
    "history": "Sinop, antik Sinope’den beri stratejik bir liman ve sürgün kenti olarak bilinir. Surlar, tarihi cezaevi ve liman dokusu; Karadeniz’in en eski yerleşim izlerinden bazılarını taşır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Sinop-Castle.jpg/1280px-Sinop-Castle.jpg",
    "landmark": "Sinop Kalesi",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Sinop-Castle.jpg/1280px-Sinop-Castle.jpg",
    "themes": [
      "Sea",
      "Culture",
      "History"
    ],
    "highlights": [
      {
        "id": "h-sinop-1",
        "title": "Sinop Kalesi",
        "shortDescription": "Denize karşı sur yürüyüşü ve liman manzarası.",
        "theme": "History",
        "locationHint": "Merkez",
        "bestSeason": "Summer",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Sinop-Castle.jpg?width=1280"
      },
      {
        "id": "h-sinop-2",
        "title": "Hamsilos Koyu",
        "shortDescription": "Fiyort benzeri doğa harikası; kısa yürüyüş ve fotoğraf.",
        "theme": "Nature",
        "locationHint": "Merkez",
        "bestSeason": "Spring",
        "imageUrl": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80"
      },
      {
        "id": "h-sinop-3",
        "title": "Liman & çarşı",
        "shortDescription": "Balıkçı tekneleri, kafeler ve sakin şehir turu.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "Summer",
        "imageUrl": "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-sinop-1",
        "title": "Liman turu",
        "shortDescription": "Kısa rota, bol fotoğraf.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "ordu",
    "name": "Ordu",
    "slogan": "Teleferikle bulutlara.",
    "story": "Ordu’da şehirden birkaç dakika uzaklaşınca manzara değişir. Boztepe teleferiğiyle yükselirken deniz geride kalır, yeşil öne çıkar. Perşembe Yaylası ve fındık bahçeleri kısa ama güçlü bir Karadeniz deneyimi sunar.",
    "history": "Ordu, antik dönemden Osmanlı’ya uzanan bir kıyı yerleşimidir. Fındık üretimi ekonominin bel kemiğidir; Boztepe ise modern şehrin simge manzara noktasıdır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/1/11/Ordu_Boztepe.jpg",
    "landmark": "Boztepe",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/1/11/Ordu_Boztepe.jpg",
    "themes": [
      "Nature",
      "Sea",
      "Adventure",
      "Food"
    ],
    "highlights": [
      {
        "id": "h-ordu-1",
        "title": "Boztepe",
        "shortDescription": "Teleferik ile manzaraya çık; çay ve fotoğraf molası.",
        "theme": "Nature",
        "locationHint": "Altınordu",
        "bestSeason": "Summer",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Ordu%20Boztepe.jpg?width=1280"
      },
      {
        "id": "h-ordu-2",
        "title": "Şehir & sahil",
        "shortDescription": "Kıyı yürüyüşü ve yerel lezzet durakları.",
        "theme": "Sea",
        "locationHint": "Altınordu",
        "bestSeason": "Summer",
        "imageUrl": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80"
      },
      {
        "id": "h-ordu-3",
        "title": "Perşembe Yaylası",
        "shortDescription": "Kıvrımlı yol, geniş yayla ve temiz hava.",
        "theme": "Adventure",
        "locationHint": "Aybastı",
        "bestSeason": "Summer",
        "imageUrl": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-ordu-1",
        "title": "Fındık rotası",
        "shortDescription": "Yerel üretim hikayesi.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "Autumn",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "giresun",
    "name": "Giresun",
    "slogan": "Ada, yayla, fındık.",
    "story": "Giresun’da gün kıyıda tuz kokusuyla başlar; biraz yükselince fındık bahçeleri ve yayla yolları devreye girer. Şehrin açığındaki ada, denizin ortasında küçük bir mola gibidir.",
    "history": "Giresun Adası (Aretias), mitolojide Amazonlarla anılır. Şehir kalesi ve fındık kültürü, Karadeniz’in üretken ve efsanevi yüzünü birlikte taşır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Giresun_Adasi_%28Amazon_Island%29_Giresun_Turkey.jpg/1280px-Giresun_Adasi_%28Amazon_Island%29_Giresun_Turkey.jpg",
    "landmark": "Giresun Adası",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Giresun_Adasi_%28Amazon_Island%29_Giresun_Turkey.jpg/1280px-Giresun_Adasi_%28Amazon_Island%29_Giresun_Turkey.jpg",
    "themes": [
      "Nature",
      "Sea",
      "Food"
    ],
    "highlights": [
      {
        "id": "h-giresun-1",
        "title": "Giresun Adası",
        "shortDescription": "Şehirden kısa tekne kaçamağı; efsane ve deniz bir arada.",
        "theme": "Sea",
        "locationHint": "Merkez",
        "bestSeason": "Summer",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Giresun%20Adasi%20%28Amazon%20Island%29%20Giresun%20Turkey.jpg?width=1280"
      },
      {
        "id": "h-giresun-2",
        "title": "Giresun Kalesi",
        "shortDescription": "Şehre ve denize hâkim tarihi bakış.",
        "theme": "History",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80"
      },
      {
        "id": "h-giresun-3",
        "title": "Kümbet Yaylası",
        "shortDescription": "Yayla havası, yürüyüş ve kahvaltı molaları.",
        "theme": "Nature",
        "locationHint": "Dereli",
        "bestSeason": "Summer",
        "imageUrl": "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-giresun-1",
        "title": "Yayla kahvaltısı",
        "shortDescription": "Yerel ürünlerle başlangıç.",
        "theme": "Food",
        "locationHint": "Kümbet",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "gumushane",
    "name": "Gümüşhane",
    "slogan": "Geçitler ve vadiler.",
    "story": "Gümüşhane, mağaraları, vadileri ve sakin rotalarıyla dinginlik arayanlar için güçlü bir duraktır. Karaca Mağarası kısa bir ziyarette bile etkileyici bir yeraltı dünyası sunar.",
    "history": "Gümüşhane adı, bölgedeki madencilik geçmişine dayanır. Tarihi geçitler, kervan yolları ve mağara oluşumları şehrin doğa ve tarih kimliğini oluşturur.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Karaca_Ma%C4%9Faras%C4%B1_%2809%29.jpg/1280px-Karaca_Ma%C4%9Faras%C4%B1_%2809%29.jpg",
    "landmark": "Karaca Mağarası",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Karaca_Ma%C4%9Faras%C4%B1_%2809%29.jpg/1280px-Karaca_Ma%C4%9Faras%C4%B1_%2809%29.jpg",
    "themes": [
      "Nature",
      "Adventure",
      "History"
    ],
    "highlights": [
      {
        "id": "h-gumushane-1",
        "title": "Karaca Mağarası",
        "shortDescription": "Sarkıt ve dikitlerle dolu kısa mağara turu.",
        "theme": "Nature",
        "locationHint": "Torul",
        "bestSeason": "All",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Karaca%20Ma%C4%9Faras%C4%B1%20%2809%29.jpg?width=1280"
      },
      {
        "id": "h-gumushane-2",
        "title": "Şehir & vadi manzarası",
        "shortDescription": "Sakin merkez ve çevredeki vadi bakışları.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "Autumn",
        "imageUrl": "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-gumushane-1",
        "title": "Vadi yürüyüşü",
        "shortDescription": "Kolay parkur.",
        "theme": "Adventure",
        "locationHint": "Torul",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "bayburt",
    "name": "Bayburt",
    "slogan": "Sakin şehir, güçlü izler.",
    "story": "Bayburt, kalesi ve taş dokusuyla kısa ama etkili bir rota sunar. Çoruh Vadisi’ne hâkim kale manzarası, şehrin en güçlü fotoğraf karesidir.",
    "history": "Bayburt Kalesi, Ortaçağ’dan kalan surlarıyla şehre hâkimdir. İpek Yolu güzergâhındaki konumu, kenti tarih boyunca önemli bir geçit haline getirmiştir.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/c/c3/Bayburt_kalesi.JPG",
    "landmark": "Bayburt Kalesi",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/c/c3/Bayburt_kalesi.JPG",
    "themes": [
      "History",
      "Culture"
    ],
    "highlights": [
      {
        "id": "h-bayburt-1",
        "title": "Bayburt Kalesi",
        "shortDescription": "Şehre hâkim kale ve çevre manzarası.",
        "theme": "History",
        "locationHint": "Merkez",
        "bestSeason": "Summer",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Bayburt%20kalesi.JPG?width=1280"
      },
      {
        "id": "h-bayburt-2",
        "title": "Tarihi merkez",
        "shortDescription": "Taş sokaklar ve sakin şehir yürüyüşü.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-bayburt-1",
        "title": "Kültür rotası",
        "shortDescription": "Kısa şehir turu.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "amasya",
    "name": "Amasya",
    "slogan": "Irmak kenarında masal.",
    "story": "Amasya, Yeşilırmak kıyısındaki yalıboyu evleri, kaya mezarları ve dar sokaklarıyla zamansız bir şehir deneyimi yaşatır. Akşam yürüyüşünde ırmak ışıkları tarihi dokuyu yumuşatır.",
    "history": "Amasya, Hitit’ten Osmanlı’ya şehzadeler şehri olarak anılır. Kaya mezarları, kale ve yalıboyu konakları UNESCO adaylık süreçleriyle de gündeme gelen güçlü bir miras oluşturur.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Amasya_Ye%C5%9Fil%C4%B1rmak_2451.jpg/1280px-Amasya_Ye%C5%9Fil%C4%B1rmak_2451.jpg",
    "landmark": "Yeşilırmak",
    "historyCoverImage": "https://commons.wikimedia.org/wiki/Special:FilePath/Amasya%20Ye%C5%9Fil%C4%B1rmak%202451.jpg?width=1280",
    "themes": [
      "History",
      "Culture",
      "Food"
    ],
    "highlights": [
      {
        "id": "h-amasya-1",
        "title": "Yalıboyu Evleri",
        "shortDescription": "Irmak kıyısında Osmanlı konakları ve yürüyüş.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "Spring",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Amasya%20Ye%C5%9Fil%C4%B1rmak%202451.jpg?width=1280"
      },
      {
        "id": "h-amasya-2",
        "title": "Kral Kaya Mezarları",
        "shortDescription": "Kayalara oyulmuş antik mezarlar.",
        "theme": "History",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80"
      },
      {
        "id": "h-amasya-3",
        "title": "Saat Kulesi & çarşı",
        "shortDescription": "Şehir merkezinde kısa kültür turu.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-amasya-1",
        "title": "Müze günü",
        "shortDescription": "Kısa tarih turu.",
        "theme": "History",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "tokat",
    "name": "Tokat",
    "slogan": "Sokaklarda lezzet.",
    "story": "Tokat, tarihi çarşıları, kalesi ve meşhur kebabıyla lezzet odaklı bir keşif vadeder. Taş sokaklarda yürürken hem kültür hem mutfak aynı rotada buluşur.",
    "history": "Tokat, Selçuklu ve Osmanlı izleriyle dolu bir Anadolu kentidir. Saat kulesi, kale ve hanlar şehrin tarihî siluetini oluşturur; mutfak kültürü ise ziyaretin vazgeçilmez parçasıdır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Tokat_Saat_Kulesi.jpg/1280px-Tokat_Saat_Kulesi.jpg",
    "landmark": "Tokat Saat Kulesi",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Tokat_Saat_Kulesi.jpg/1280px-Tokat_Saat_Kulesi.jpg",
    "themes": [
      "Food",
      "Culture",
      "History"
    ],
    "highlights": [
      {
        "id": "h-tokat-1",
        "title": "Tarihi çarşı & saat kulesi",
        "shortDescription": "Yerel tatlar, dükkanlar ve şehir silueti.",
        "theme": "Food",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Tokat%20Saat%20Kulesi.jpg?width=1280"
      },
      {
        "id": "h-tokat-2",
        "title": "Tokat Kalesi",
        "shortDescription": "Şehre bakan tarihi kale yürüyüşü.",
        "theme": "History",
        "locationHint": "Merkez",
        "bestSeason": "Spring",
        "imageUrl": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-tokat-1",
        "title": "Lezzet rotası",
        "shortDescription": "3 duraklık kebap ve yerel tat planı.",
        "theme": "Food",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "corum",
    "name": "Çorum",
    "slogan": "Taşın hafızası.",
    "story": "Çorum, Hitit başkenti Hattuşa ve Yazılıkaya ile dünya mirası bir tarih rotası sunar. Şehir merkezindeki müzeler ve lezzet duraklarıyla günü tamamlamak kolaydır.",
    "history": "Hattuşa, Hitit İmparatorluğu’nun başkentiydi. Surlar, tapınaklar ve Yazılıkaya açık hava tapınağı UNESCO Dünya Mirası listesindedir; Çorum bu mirasın kapısıdır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Lion_Gate%2C_Hattusa_01.jpg/1280px-Lion_Gate%2C_Hattusa_01.jpg",
    "landmark": "Hattuşa",
    "historyCoverImage": "https://commons.wikimedia.org/wiki/Special:FilePath/Lion%20Gate%2C%20Hattusa%2001.jpg?width=1280",
    "themes": [
      "History",
      "Culture",
      "Food"
    ],
    "highlights": [
      {
        "id": "h-corum-1",
        "title": "Hattuşa",
        "shortDescription": "Hitit başkentinin surları ve tapınak kalıntıları.",
        "theme": "History",
        "locationHint": "Boğazkale",
        "bestSeason": "Spring",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Lion%20Gate%2C%20Hattusa%2001.jpg?width=1280"
      },
      {
        "id": "h-corum-2",
        "title": "Yazılıkaya",
        "shortDescription": "Kaya tapınağı ve kabartmalar.",
        "theme": "History",
        "locationHint": "Boğazkale",
        "bestSeason": "Spring",
        "imageUrl": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-corum-1",
        "title": "Müze + şehir",
        "shortDescription": "Yarım günlük plan.",
        "theme": "Culture",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "kastamonu",
    "name": "Kastamonu",
    "slogan": "Orman, kanyon, köy.",
    "story": "Kastamonu, Ilgaz ormanları, Valla Kanyonu ve köy yaşamıyla doğaya yakın bir rota sunar. Kale ve tarihi çarşı ise şehir merkezine kültür katmanı ekler.",
    "history": "Kastamonu, Osmanlı döneminde önemli bir eyalet merkezidir. Ahşap konaklar, kale ve çevre milli parkları; kültür ile doğayı aynı güzergâhta buluşturur.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Ilgaz_Mountain_National_Park.jpg/1280px-Ilgaz_Mountain_National_Park.jpg",
    "landmark": "Ilgaz Dağları",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Ilgaz_Mountain_National_Park.jpg/1280px-Ilgaz_Mountain_National_Park.jpg",
    "themes": [
      "Nature",
      "Adventure",
      "Culture"
    ],
    "highlights": [
      {
        "id": "h-kastamonu-1",
        "title": "Ilgaz Dağları",
        "shortDescription": "Orman, temiz hava ve mevsimlik doğa aktiviteleri.",
        "theme": "Nature",
        "locationHint": "Ilgaz",
        "bestSeason": "Winter",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Ilgaz%20Mountain%20National%20Park.jpg?width=1280"
      },
      {
        "id": "h-kastamonu-2",
        "title": "Valla Kanyonu",
        "shortDescription": "Derin kanyon manzarası ve seyir noktaları.",
        "theme": "Adventure",
        "locationHint": "Pınarbaşı",
        "bestSeason": "Summer",
        "imageUrl": "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&q=80"
      },
      {
        "id": "h-kastamonu-3",
        "title": "Kastamonu Kalesi",
        "shortDescription": "Şehir merkezinde tarihi bakış.",
        "theme": "History",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-kastamonu-1",
        "title": "Doğa günü",
        "shortDescription": "Kolay rota.",
        "theme": "Nature",
        "locationHint": "Ilgaz",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "bartin",
    "name": "Bartın",
    "slogan": "Kıyıda sakinlik.",
    "story": "Bartın, Amasra’nın limanı, kalesi ve renkli evleriyle dinlendirici bir kıyı kaçamağı sunar. Gün batımında liman yürüyüşü şehrin en sakin ritmidir.",
    "history": "Amasra (eski Amastris), antik liman kenti olarak bilinir. Ceneviz ve Bizans izleri kale surlarında; Osmanlı dokusu ise liman çevresindeki evlerde sürer.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Amasra%2C_2016_03.jpg/1280px-Amasra%2C_2016_03.jpg",
    "landmark": "Amasra",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Amasra%2C_2016_03.jpg/1280px-Amasra%2C_2016_03.jpg",
    "themes": [
      "Sea",
      "Nature",
      "History"
    ],
    "highlights": [
      {
        "id": "h-bartin-1",
        "title": "Amasra limanı",
        "shortDescription": "Renkli kıyı, tekne manzarası ve kafeler.",
        "theme": "Sea",
        "locationHint": "Amasra",
        "bestSeason": "Summer",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Amasra%2C%202016%2003.jpg?width=1280"
      },
      {
        "id": "h-bartin-2",
        "title": "Amasra Kalesi",
        "shortDescription": "Denize bakan tarihi surlar.",
        "theme": "History",
        "locationHint": "Amasra",
        "bestSeason": "Summer",
        "imageUrl": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-bartin-1",
        "title": "Kıyı yürüyüşü",
        "shortDescription": "Gün batımı rotası.",
        "theme": "Sea",
        "locationHint": "Amasra",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "karabuk",
    "name": "Karabük",
    "slogan": "Safran kokusu.",
    "story": "Karabük denince akla Safranbolu gelir: UNESCO’luk konaklar, dar sokaklar ve Cinci Han. Bir gün bile tarihi dokuyu doyasıya gezmeye yeter.",
    "history": "Safranbolu, Osmanlı sivil mimarisinin en iyi korunan örneklerinden biridir. UNESCO Dünya Mirası listesindeki çarşı, konaklar ve hanlar ziyaretçiyi yüzyıllar öncesine taşır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Safranbolu_houses_in_2006_8307b.jpg/1280px-Safranbolu_houses_in_2006_8307b.jpg",
    "landmark": "Safranbolu",
    "historyCoverImage": "https://commons.wikimedia.org/wiki/Special:FilePath/Safranbolu%20houses%20in%202006%208307b.jpg?width=1280",
    "themes": [
      "Culture",
      "History",
      "Food"
    ],
    "highlights": [
      {
        "id": "h-karabuk-1",
        "title": "Safranbolu evleri",
        "shortDescription": "Tarihi konaklar ve taş sokaklar.",
        "theme": "Culture",
        "locationHint": "Safranbolu",
        "bestSeason": "Spring",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Safranbolu%20houses%20in%202006%208307b.jpg?width=1280"
      },
      {
        "id": "h-karabuk-2",
        "title": "Cinci Han & çarşı",
        "shortDescription": "Han avlusu, yerel ürünler ve kahve molası.",
        "theme": "History",
        "locationHint": "Safranbolu",
        "bestSeason": "All",
        "imageUrl": "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-karabuk-1",
        "title": "Çarşı turu",
        "shortDescription": "Kısa kültür rotası.",
        "theme": "Culture",
        "locationHint": "Safranbolu",
        "bestSeason": "All",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "zonguldak",
    "name": "Zonguldak",
    "slogan": "Mavi ve yeşil arası.",
    "story": "Zonguldak, sahil bandı ve yeşil yamaçlarıyla kısa kaçamaklar için dengeli bir seçenektir. Deniz manzarası ile maden kenti kimliği yan yana durur.",
    "history": "Zonguldak, Türkiye’nin kömür madenciliği tarihinde merkezi bir rol oynar. Sahil düzenlemeleri ve müzeler, sanayi geçmişini güncel şehir yaşamıyla buluşturur.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Sahil_%28Zonguldak%29.jpg/1280px-Sahil_%28Zonguldak%29.jpg",
    "landmark": "Zonguldak Sahili",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Sahil_%28Zonguldak%29.jpg/1280px-Sahil_%28Zonguldak%29.jpg",
    "themes": [
      "Sea",
      "Nature",
      "History"
    ],
    "highlights": [
      {
        "id": "h-zonguldak-1",
        "title": "Sahil bandı",
        "shortDescription": "Deniz manzaralı yürüyüş ve fotoğraf durakları.",
        "theme": "Sea",
        "locationHint": "Merkez",
        "bestSeason": "Summer",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Sahil%20%28Zonguldak%29.jpg?width=1280"
      },
      {
        "id": "h-zonguldak-2",
        "title": "Şehir & yeşil tepeler",
        "shortDescription": "Kıyıdan yükselen manzara noktaları.",
        "theme": "Nature",
        "locationHint": "Merkez",
        "bestSeason": "Autumn",
        "imageUrl": "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-zonguldak-1",
        "title": "Günübirlik rota",
        "shortDescription": "Kolay plan.",
        "theme": "Nature",
        "locationHint": "Merkez",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "duzce",
    "name": "Düzce",
    "slogan": "Şelaleler ve yaylalar.",
    "story": "Düzce, Güzeldere Şelalesi ve Efteni Gölü ile doğa odaklı bir gün planı için güçlü alternatifler sunar. İstanbul’a yakınlığıyla da hafta sonu kaçamağına uygundur.",
    "history": "Düzce, 1999 depreminin ardından yeniden şekillenen bir kenttir. Çevresindeki şelaleler, göller ve yaylalar doğa turizminin ana çekim noktalarıdır.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/G%C3%BCzeldere_%C5%9Eelalesi_3.jpg/1280px-G%C3%BCzeldere_%C5%9Eelalesi_3.jpg",
    "landmark": "Güzeldere Şelalesi",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/G%C3%BCzeldere_%C5%9Eelalesi_3.jpg/1280px-G%C3%BCzeldere_%C5%9Eelalesi_3.jpg",
    "themes": [
      "Nature",
      "Adventure"
    ],
    "highlights": [
      {
        "id": "h-duzce-1",
        "title": "Güzeldere Şelalesi",
        "shortDescription": "Kısa yürüyüşle ulaşılan güçlü su manzarası.",
        "theme": "Nature",
        "locationHint": "Gölyaka",
        "bestSeason": "Spring",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/G%C3%BCzeldere%20%C5%9Eelalesi%203.jpg?width=1280"
      },
      {
        "id": "h-duzce-2",
        "title": "Efteni Gölü",
        "shortDescription": "Kuş gözlemi ve sakin göl çevresi.",
        "theme": "Nature",
        "locationHint": "Gölyaka",
        "bestSeason": "Autumn",
        "imageUrl": "https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-duzce-1",
        "title": "Doğa parkuru",
        "shortDescription": "Kolay parkur.",
        "theme": "Adventure",
        "locationHint": "Gölyaka",
        "bestSeason": "Summer",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  },
  {
    "id": "bolu",
    "name": "Bolu",
    "slogan": "Göl kenarında nefes.",
    "story": "Bolu, Abant ve Gölcük gölleriyle her mevsim nefes aldıran bir duraktır. Orman içi yürüyüşler, göl çevresi ve yerel lezzetler aynı günde birleşir.",
    "history": "Bolu, Osmanlı mutfak geleneği ve orman gölleriyle ünlüdür. Abant, Cumhuriyet döneminden beri dinlenme ve doğa turizminin simge destinasyonlarından biridir.",
    "heroImage": "https://upload.wikimedia.org/wikipedia/commons/7/71/Abant_G%C3%B6l%C3%BC_29_ekim.jpg",
    "landmark": "Abant Gölü",
    "historyCoverImage": "https://upload.wikimedia.org/wikipedia/commons/7/71/Abant_G%C3%B6l%C3%BC_29_ekim.jpg",
    "themes": [
      "Nature",
      "Food"
    ],
    "highlights": [
      {
        "id": "h-bolu-1",
        "title": "Abant Gölü",
        "shortDescription": "Göl çevresi yürüyüşü ve mevsimlik manzaralar.",
        "theme": "Nature",
        "locationHint": "Abant",
        "bestSeason": "Autumn",
        "imageUrl": "https://commons.wikimedia.org/wiki/Special:FilePath/Abant%20G%C3%B6l%C3%BC%2029%20ekim.jpg?width=1280"
      },
      {
        "id": "h-bolu-2",
        "title": "Gölcük",
        "shortDescription": "Orman içinde sakin göl molası.",
        "theme": "Nature",
        "locationHint": "Merkez",
        "bestSeason": "Spring",
        "imageUrl": "https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=1200&q=80"
      }
    ],
    "experiences": [
      {
        "id": "e-bolu-1",
        "title": "Lezzet molası",
        "shortDescription": "Yerel tatlar ve kırsal kahvaltı.",
        "theme": "Food",
        "locationHint": "Merkez",
        "bestSeason": "All",
        "imageUrl": null
      }
    ],
    "seasons": [
      "Spring",
      "Summer",
      "Autumn",
      "Winter"
    ],
    "foods": []
  }
];
